import type { TObject } from '@altirllc/shared/utils/types/common';

export const isEmpty = (value: unknown): boolean => {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string') {
    return !value;
  }

  if (Array.isArray(value)) {
    return value.length === 0;
  }

  if (typeof value === 'object') {
    return Object.values(value as TObject).every(isEmpty);
  }

  return false;
};
